export default {
  "archive-success": {
    EN: "Successfully archived Contact",
  },
  "archive-failure": {
    EN: "Failed to archive Contact",
  },
  "create-failure": {
    EN: "Failed to create Contact.",
  },
  "create-exists": {
    EN: "Failed to create Contact. A similar one already exists",
  },
  "create-success": {
    EN: "Successfully created Contact.",
  },
  "load-failure": {
    EN: "Failed to load the Contact details. Please try again later.",
  },
  "update-success": {
    EN: "Successfully updated Contact.",
  },
  "update-failure": {
    EN: "Failed to update Contact. Please try again later.",
  },
  "merge-success": {
    EN: "Successfully merged.",
  },
  "merge-failure": {
    EN: "Failed to merge Contacts. Please try again later.",
  },
  "upload-url-success": {
    EN: "Uploaded image successfully",
  },
  "upload-url-failure": {
    EN: "Failed to upload image",
  },
  "update-company-project-file-folder-id-success": {
    EN: "Updated successfully!",
  },
  "update-company-project-file-folder-id-failure": {
    EN: "Something went wrong while updating the folder Id",
  },
  "update-notes-success": {
    EN: "Successfully updated company notes",
  },
  "update-notes-failure": {
    EN: "Failed to update company notes",
  },
};
